import { Dispatch, SetStateAction } from 'react';

import { ReactPortal } from '../../../../components/reactPortal';
import { RootState } from 'lib/centralStore';
import { SlotArchiveFiltersModalFooter } from './components/slotArchiveFiltersModalFooter';
import { SlotArchiveFiltersModalHeader } from './components/slotArchiveFiltersModalHeader';
import { SlotArchiveFiltersModalRow } from './components/slotArchiveFiltersModalRow';
import { SlotFilter } from 'features/slotArchive/SlotArchive';
import { isTruthy } from 'utility/functions';
import styles from './SlotArchiveFiltersModal.module.scss';
import { useSelector } from 'react-redux';

export type SlotArchiveFiltersModalProps = {
  title: string;
  resetLabel: string;
  dismissModalLabel: string;
  functionalityFilter: SlotFilter;
  linesFilter: SlotFilter;
  volatilityFilter: SlotFilter;
  producerFilter: SlotFilter;
  categoryFilter: SlotFilter;
  isOpen: boolean;
  setOn: Dispatch<SetStateAction<boolean>>;
  handleResetClick: Function;
  handleFilterChange: Function;
  handleClickViewResults: Function;
};

export const SlotArchiveFiltersModal = ({
  title,
  resetLabel,
  dismissModalLabel,
  functionalityFilter,
  linesFilter,
  volatilityFilter,
  producerFilter,
  categoryFilter,
  isOpen,
  setOn,
  handleResetClick,
  handleFilterChange,
  handleClickViewResults,
}: SlotArchiveFiltersModalProps) => {
  const { selectedFilters } = useSelector((store: RootState) => store.archiveSlot);

  if (!isOpen) return null;

  return (
    <ReactPortal wrapperId="SlotArchiveFiltersModal">
      <div className={styles.overlay}>
        <div className={styles.modal}>
          <SlotArchiveFiltersModalHeader title={title} setOn={setOn}></SlotArchiveFiltersModalHeader>
          <div className={styles.content}>
            {isTruthy(functionalityFilter?.values?.length) && (
              <div className={styles.filtersContainer}>
                <SlotArchiveFiltersModalRow
                  id={functionalityFilter.label}
                  values={functionalityFilter.values ?? []}
                  // valuesTrKey={[]}
                  typeOfItem={functionalityFilter.typeOfItem}
                  tooltipLabel={functionalityFilter.label}
                  tooltipContent={functionalityFilter.tooltipContent}
                  selectedValues={selectedFilters.functionality}
                  handleFilterChange={(filterType: string, el: HTMLInputElement) => handleFilterChange(filterType, el)}
                />
              </div>
            )}
            {isTruthy(linesFilter?.values?.length) && (
              <div className={styles.filtersContainer}>
                <SlotArchiveFiltersModalRow
                  id={linesFilter.label}
                  values={linesFilter.values ?? []}
                  // valuesTrKey={[]}
                  typeOfItem={linesFilter.typeOfItem}
                  tooltipLabel={linesFilter.label}
                  tooltipContent={linesFilter.tooltipContent}
                  selectedValues={selectedFilters.lines}
                  handleFilterChange={(filterType: string, el: HTMLInputElement) => handleFilterChange(filterType, el)}
                />
              </div>
            )}
            {isTruthy(volatilityFilter?.values?.length) && (
              <div className={styles.filtersContainer}>
                <SlotArchiveFiltersModalRow
                  id={volatilityFilter.label}
                  values={volatilityFilter.values ?? []}
                  // valuesTrKey={[]}
                  typeOfItem={volatilityFilter.typeOfItem}
                  tooltipLabel={volatilityFilter.label}
                  tooltipContent={volatilityFilter.tooltipContent}
                  selectedValues={selectedFilters.volatility}
                  handleFilterChange={(filterType: string, el: HTMLInputElement) => handleFilterChange(filterType, el)}
                />
              </div>
            )}
            {isTruthy(producerFilter?.values?.length) && (
              <div className={styles.filtersContainer}>
                <SlotArchiveFiltersModalRow
                  id={producerFilter.label}
                  values={producerFilter.values ?? []}
                  // valuesTrKey={[]}
                  typeOfItem={producerFilter.typeOfItem}
                  tooltipLabel={producerFilter.label}
                  tooltipContent={producerFilter.tooltipContent}
                  selectedValues={selectedFilters.producer}
                  handleFilterChange={(filterType: string, el: HTMLInputElement) => handleFilterChange(filterType, el)}
                />
              </div>
            )}
            {isTruthy(categoryFilter?.values?.length) && (
              <div className={styles.filtersContainer}>
                <SlotArchiveFiltersModalRow
                  id={categoryFilter.label}
                  values={categoryFilter.values ?? []}
                  // valuesTrKey={[]}
                  typeOfItem={categoryFilter.typeOfItem}
                  tooltipLabel={categoryFilter.label}
                  tooltipContent={categoryFilter.tooltipContent}
                  selectedValues={selectedFilters.category}
                  handleFilterChange={(filterType: string, el: HTMLInputElement) => handleFilterChange(filterType, el)}
                />
              </div>
            )}
          </div>
          <SlotArchiveFiltersModalFooter
            resetLabel={resetLabel}
            isSelected={
              !!selectedFilters.lines.length ||
              !!selectedFilters.producer.length ||
              !!selectedFilters.category.length ||
              !!selectedFilters.volatility.length ||
              !!selectedFilters.functionality.length
            }
            dismissModalLabel={dismissModalLabel}
            setOn={setOn}
            handleResetClick={handleResetClick}
            handleClickViewResults={handleClickViewResults}
          ></SlotArchiveFiltersModalFooter>
        </div>
      </div>
    </ReactPortal>
  );
};
